"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWidgetToolbarButtons = void 0;
var Image_1 = require("@CommonFrontend/ContentTokens/Models/Image");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var react_1 = __importDefault(require("react"));
var AltTextPanel_1 = __importDefault(require("./AltTextPanel/AltTextPanel"));
var AltTextPanel_2 = require("./AltTextPanel/AltTextPanel");
var ImageWidget_1 = require("./ImageWidget");
var LinkEditor_1 = require("./LinkEditor/LinkEditor");
var ImageWidgetContext_1 = require("./ImageWidgetContext");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Types_1 = require("@CommonFrontend/Tokens/Types");
var TokenMenu_1 = require("../TokenMenu/TokenMenu");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var ImageWidgetToolbarButtons = function (_a) {
    var element = _a.element;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var handleClickChooseImage = function () {
        var data = {
            action: "chooseImage",
            path: widgetManager.getPath(element),
        };
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", data));
    };
    var imageFramesEnabled = (0, inversify_react_1.useInjection)("usingFeature")(FeatureFlag_1.default.ImageFrames);
    var _b = (0, ImageWidgetContext_1.useImageWidgetContext)(), mode = _b.state.mode, _c = _b.actions, startLinkEditing = _c.startLinkEditing, finishRepositioning = _c.finishRepositioning, finishLinkEditing = _c.finishLinkEditing, startAddEditToken = _c.startAddEditToken, finishAddEditToken = _c.finishAddEditToken;
    var tokensEnableState = (0, inversify_react_1.useInjection)("tokensEnableState");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        mode === "none" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Link, null), onClick: function () {
                    startLinkEditing();
                }, tooltip: { content: element.data.href ? "Edit link" : "Add link" } }),
            imageFramesEnabled && (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Frame, null), tooltip: { content: "Image frames" } }))); } },
                react_1.default.createElement("div", { className: tokens_1.darkTheme },
                    react_1.default.createElement(ImageFrameControls, { element: element })))),
            tokensEnableState !== Types_1.TokensEnableState.Disabled && (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Tokens, null), onClick: startAddEditToken, tooltip: { content: element.data.variable ? "Edit token" : "Add token" } })),
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Image, null), onClick: handleClickChooseImage, tooltip: { content: "Swap image" } }),
            react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.AltText, null), tooltip: { content: "Add alt text" } }))); } },
                react_1.default.createElement(AltTextPanel_1.default, { alt: element.data.alt, role: element.data.role, updateAltText: function (altText, isImageDecorative) {
                        var updateImage = function (toUpdate) {
                            var updateData = {
                                action: "update",
                                path: widgetManager.getPath(element),
                                toUpdate: toUpdate,
                            };
                            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
                        };
                        if (isImageDecorative) {
                            updateImage({ role: AltTextPanel_2.RoleAttributeState.Presentation });
                        }
                        else if (altText) {
                            updateImage({ alt: altText, role: AltTextPanel_2.RoleAttributeState.Empty });
                        }
                        else {
                            updateImage({ alt: AltTextPanel_2.AltTextAttributeState.Empty, role: AltTextPanel_2.RoleAttributeState.Empty });
                        }
                    } })))),
        mode === "editLink" && (react_1.default.createElement(LinkEditor_1.ImageWidgetLinkEditor, { element: element, onClose: function () {
                finishLinkEditing();
            } })),
        mode === "editPositioning" && (react_1.default.createElement(RepositioningControls, { element: element, onClose: function () {
                finishRepositioning();
            } })),
        mode === "addEditToken" && (react_1.default.createElement(TokenMenu_1.TokenMenu, { type: Types_2.TokenDataType.String, token: element.data.variable, removeToken: function () {
                var updateData = {
                    action: "update",
                    path: widgetManager.getPath(element),
                    toUpdate: {
                        variable: null,
                    },
                };
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
                finishAddEditToken();
            }, confirmToken: function (token) {
                var toUpdate = {
                    variable: {
                        name: token.apiName,
                        label: token.name,
                        substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
                    },
                };
                var updateData = {
                    action: "update",
                    path: widgetManager.getPath(element),
                    toUpdate: toUpdate,
                };
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
                finishAddEditToken();
            }, close: function () {
                finishAddEditToken();
            }, matchEWRStyling: true }))));
};
exports.ImageWidgetToolbarButtons = ImageWidgetToolbarButtons;
var RepositioningControls = (0, mobx_react_1.observer)(function (_a) {
    var element = _a.element, onClose = _a.onClose;
    var positioningStore = (0, ImageWidgetContext_1.useImageWidgetContext)().positioningStore;
    var zoomLevel = positioningStore.tempScale;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var updateZoomLevel = function (nextValue) {
        (0, mobx_1.runInAction)(function () {
            positioningStore.tempScale = Math.max(ImageWidget_1.MIN_SCALE, Math.min(ImageWidget_1.MAX_SCALE, nextValue));
        });
    };
    var zoomOut = function () {
        updateZoomLevel(zoomLevel - 0.5);
    };
    var zoomIn = function () {
        updateZoomLevel(zoomLevel + 0.5);
    };
    var handleSliderChange = function (nextZoom) {
        updateZoomLevel(nextZoom);
    };
    var handleConfirm = function () {
        var updateData = {
            action: "update",
            path: widgetManager.getPath(element),
            toUpdate: {
                scale: positioningStore.tempScale,
                translation: positioningStore.tempTranslation,
            },
        };
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
        onClose();
    };
    var handleCancel = function () {
        var _a, _b;
        positioningStore.tempScale = (_a = element.data.scale) !== null && _a !== void 0 ? _a : 1;
        positioningStore.tempTranslation = (_b = element.data.translation) !== null && _b !== void 0 ? _b : { x: 0, y: 0 };
        onClose();
    };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xxs", align: "center" },
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.ZoomOut, null), onClick: zoomOut }),
        react_1.default.createElement("div", { style: { width: "246px" } },
            react_1.default.createElement(kaleidoscope_1.Slider, { label: "zoom level", theme: kaleidoscope_1.SliderTheme.Dark, stepSize: 0.1, minimum: ImageWidget_1.MIN_SCALE, maximum: ImageWidget_1.MAX_SCALE, value: zoomLevel, onChange: handleSliderChange })),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.ZoomIn, null), onClick: zoomIn }),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Tick, null), onClick: handleConfirm }),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: handleCancel })));
});
var ImageFrameControls = function (_a) {
    var _b;
    var element = _a.element;
    var editorTelemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var _c = (0, ImageWidgetContext_1.useImageWidgetContext)(), positioningStore = _c.positioningStore, startRepositioning = _c.actions.startRepositioning;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    if (!(0, EditorWidgetRegistry_1.isResizeableWidget)(element)) {
        throw new Error("Image widgets are always resizeable");
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Image frame", theme: kaleidoscope_1.SegmentedControlTheme.Dark, options: [
                {
                    label: "none",
                    value: Image_1.ImageFrame.None,
                    icon: react_1.default.createElement(icons_1.FrameNone, null),
                    tooltipMessage: "No frame",
                },
                {
                    label: "circle",
                    value: Image_1.ImageFrame.Circle,
                    icon: react_1.default.createElement(icons_1.FrameCircle, null),
                    tooltipMessage: "Circle frame",
                },
            ], onClickHandler: function (selectedValue) {
                editorTelemetry.changedImageFrame(selectedValue);
                if (selectedValue === element.data.frame) {
                    return;
                }
                var delta = { frame: selectedValue };
                if (selectedValue === Image_1.ImageFrame.Circle) {
                    if (element.data.aspectRatio != undefined && element.data.aspectRatio > 1) {
                        if (typeof element.data.width === "number") {
                            delta.width = element.data.width / element.data.aspectRatio;
                        }
                    }
                }
                else {
                    if (element.data.aspectRatio != undefined && element.data.aspectRatio > 1) {
                        if (typeof element.data.width === "number") {
                            delta.width = Math.min(100, element.data.width * element.data.aspectRatio);
                        }
                    }
                    positioningStore.tempTranslation = { x: 0, y: 0 };
                    positioningStore.tempScale = 1;
                    delta.scale = positioningStore.tempScale;
                    delta.translation = positioningStore.tempTranslation;
                }
                var updateData = {
                    action: "update",
                    path: widgetManager.getPath(element),
                    toUpdate: delta,
                };
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
            }, selectedValue: (_b = element.data.frame) !== null && _b !== void 0 ? _b : Image_1.ImageFrame.None }),
        element.data.frame === Image_1.ImageFrame.Circle && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, width: "full", size: kaleidoscope_1.ButtonSize.Small, onClick: function () {
                startRepositioning();
            } }, "Reposition in frame"))));
};
